<template>
  <div :class="$route.name==='Login' || $route.name==='Signup'?'login-screens':''">
    <footer class="footer">
      <div class="footer-container">
        <span class="footer-text  t-text-color">{{copyMsg}}</span>
        <div class="footer-right-info">
          <a :href="$store.getters.settings.client.powered_by_link"
             v-html="$store.getters.settings.client.powered_by_label" target="_blank" class="footer-text t-text-color">
          </a>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
  export default {
    computed: {
      copyMsg () {
        let d = new Date()
        return '© ' + d.getFullYear() + ' ' + this.$store.getters.settings.client.name + ' All rights reserved.'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue